import './style.scss';
import { CreateTeamSteps } from '../Components/CreateTeamSteps/CreateTeamSteps';
import {
  Button,
  PopoverItem,
} from '@trufla-technology/trumarket-react-design-system';
import { ProductsCard } from './Components/ProductsCard/ProductsCard';
import { AssignProductsToTeam } from './Components/AssignProductsToTeam/index';
import { AssignRequestsToProduct } from './Components/AssignRequestsToProduct/index';
import { useListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { EditTeamSteps } from '../Components/EditTeamSteps/EditTeamSteps';
import { Loading } from '@trufla-technology/trumarket-react-design-system';
import { useHistory, useParams } from 'react-router-dom';
import { ListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { FormEvent, useEffect } from 'react';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
interface IParamTypes {
  teamKey: string;
}
interface IProps {
  mode?: string;
}
export const TeamProducts = (props: IProps) => {
  const { isPermitted } = useAuthContext();
  const history = useHistory();
  const { teamKey } = useParams<IParamTypes>();

  const { data, loading, get } = useListProductDefinitions({
    filter: { teamKeys: [teamKey] },
    paginate: { offset: 0, limit: 100 },
  });
  const handleNext = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (props.mode === 'edit') {
      history.push(`/configurations/teams/team-users/${teamKey}`);
    } else {
      history.push(`/configurations/teams/team-users/create/${teamKey}`);
    }
  };
  useEffect(() => {
    if (props.mode !== 'edit') {
      history.replace({ search: 'assign=products-to-team' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="teams-products">
      <form onSubmit={handleNext}>
        {props.mode === 'edit' ? (
          <EditTeamSteps />
        ) : (
          <CreateTeamSteps step={3} />
        )}
      </form>
      <div className="users-list">
        <div className=" btn-add-products">
          {isPermitted('listRequestDefinitions') &&
            isPermitted('assignRequestDefinitionsToTeams') && (
              <div>
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={() => {
                    history.replace({ search: 'assign=products-to-team' });
                  }}
                >
                  Add Products
                </Button>
                <PopoverItem
                  match="assign=products-to-team"
                  title="Add Product"
                  onClose={() => {
                    history.replace({ search: '' });
                  }}
                  showBackArrow={true}
                  component={() => <AssignProductsToTeam />}
                />
                <PopoverItem
                  match="assign-requests"
                  title={'Product Configure '}
                  onClose={() => history.goBack()}
                  onSave={() => history.replace({ search: '' })}
                  showBackArrow={true}
                  component={() => (
                    <AssignRequestsToProduct
                      creatingTeam
                      teamKey={teamKey}
                      getProduct={() => get()}
                    />
                  )}
                />
              </div>
            )}
        </div>
        <div className="users-list-scroll">
          {loading && <Loading />}
          {!loading &&
            data?.map((x: ListProductDefinitions[number]) => {
              return (
                <div className="card-w" key={x.key}>
                  <ProductsCard data={x} teamKey={teamKey} getProducts={get} />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
